var dotsPositionData = ['inside bottom', 'inside top', 'outside bottom', 'outside top'];
export default dotsPositionData;